export default __webpack_public_path__ + "static/media/carrinho@3x.ce7734f0.png";